import {
  REQUEST_SPONSOR_LIST_FOR_MAIN_PAGE,
  REQUEST_SPONSOR_LIST,
  REQUEST_CAMPAIGN_SPONSOR_LIST,
  REQUEST_SPONSOR
} from './mutation-types';

export default {
  [REQUEST_SPONSOR_LIST_FOR_MAIN_PAGE] (state, receivedData) {
    state.mainPageSponsors = receivedData
  },
  [REQUEST_SPONSOR_LIST] (state, receivedData) {
    state.sponsors = receivedData.content;
    state.sponsorCount = receivedData.totalElements;
  },
  [REQUEST_CAMPAIGN_SPONSOR_LIST] (state, receivedData) {
    state.campaigns = receivedData.content;
    state.campaignCount = receivedData.totalElements;
  },
  [REQUEST_SPONSOR] (state, receivedData) {
    state.sponsor = receivedData
  }
}